<template>
  <div>
    <div class="advanceParent">
      <app-history
        @clicked="showDialog = true"
        class="advancedSearch"
        title="تعیین بازه"
      />
      <export-excel
        :data="report"
        :fields="excelHeaders"
        worksheet="My Worksheet"
        name="گزارش جامع مدارس.xls"
      >
        <app-history class="advancedSearch" title="خروجی اکسل" />
      </export-excel>
    </div>
    <div>
      <v-data-table
        :items="report"
        :headers="reportHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.manualPayments`]="{ item }">
          {{ Number(item.manualPayments).toLocaleString() }}
        </template>
        <template v-slot:[`item.internetPayments`]="{ item }">
          {{ Number(item.internetPayments).toLocaleString() }}
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ شروع: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="StartDate"
            @click="onClickDate(1)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ پایان: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="EndDate"
            @click="onClickDate(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="GetBranchReport"
          :disabled="apiRunning"
        >
          جستجو
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <date-picker
      ref="datepicker1"
      v-model="StartDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      @change="onChangeDate($event, 1)"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker
      ref="datepicker2"
      v-model="EndDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput2"
      @change="onChangeDate($event, 2)"
    ></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetBranchReport } from "@/api/branch";
import moment from "moment-jalaali";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      report: [],

      StartDate: "",
      EndDate: "",
      reportHeaders: [
        {
          text: "شناسه مدرسه",
          value: "schoolId",
        },
        {
          text: "نام شعبه",
          value: "name",
        },

        {
          text: "تعداد سفارشات",
          value: "totalOrders",
        },
        {
          text: "تعداد صبحانه",
          value: "totalBreakfasts",
        },
        {
          text: "تعداد ناهار",
          value: "totalLunches",
        },
        {
          text: "تعداد شام",
          value: "totalDinners",
        },
        {
          text: "تعداد سایر وعده ها",
          value: "totalOthers",
        },
        {
          text: "جمع پرداخت های دستی (ریال)",
          value: "manualPayments",
        },
        {
          text: "جمع پرداخت های اینترنتی (ریال)",
          value: "internetPayments",
        },
      ],
      excelHeaders: {
        "شناسه مدرسه": "schoolId",
        "نام شعبه": "name",
        "تعداد سفارشات": "totalOrders",
        "تعداد صبحانه": "totalBreakfasts",
        "تعداد ناهار": "totalLunches",
        "تعداد شام": "totalDinners",
        "تعداد سایر وعده ها": "totalOthers",
        "جمع پرداخت های دستی (ریال)": {
          field: "manualPayments",
          callback: (value) => {
            return Number(value).toLocaleString();
          },
        },
        "جمع پرداخت های اینترنتی (ریال)": {
          field: "internetPayments",
          callback: (value) => {
            return Number(value).toLocaleString();
          },
        },
      },
    };
  },
  created() {
    this.showDialog = true;
    this.$store.commit("SET_TABLE_TEXT", false);
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },

  methods: {
    onChangeDate($event, input) {
      if (input == 1) {
        this.StartDate = $event.format("jYYYY/jMM/jDD");
      } else {
        this.EndDate = $event.format("jYYYY/jMM/jDD");
      }
    },
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },

    GetBranchReport() {
      let text = "";
      if (this.StartDate == "" || this.EndDate == "") {
        text = "تاریخ شروع و پایان بایستی مشخص شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);
        return;
      }

      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetBranchReport(this.StartDate, this.EndDate)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.report = response.data.items;
            this.totalCount = response.data.count;
            this.$store.commit("SET_TABLE_TEXT", false);
            this.showDialog = false;

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    convertDate(date) {
      return moment(date).format("HH:mm jYYYY/jMM/jDD");
    },
  },
};
</script>
<style>
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}

.filterButton {
  width: 100%;
}
</style>
